import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-ac-report-layout-line',
  templateUrl: './ac-report-layout-line.component.html',
  styleUrls: ['./ac-report-layout-line.component.css']
})
export class AcReportLayoutLineComponent implements OnInit {
    acReportLayoutKeyno;

    acReportLayoutLineKeyno;

    public edit?: Edit;

    public selectListLineTypes: Item[] = [];

    public saving = false;

    public deleting = false;

    constructor(private state: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.acReportLayoutKeyno = this.state.getStateParams()['acreportlayout_keyno'];
        this.acReportLayoutLineKeyno = this.state.getStateParams()['acreportlayoutline_keyno'];
    }

    private async loadEdit() {
        if (!!this.acReportLayoutKeyno) {
            this.edit = (await this.datatask.Post(2806, {
                acreportlayout_keyno: this.acReportLayoutKeyno,
                acreportlayoutline_keyno: this.acReportLayoutLineKeyno
            }))[0];
        }
    }

    private async loadLineTypes(): Promise<void> {
        this.selectListLineTypes = await this.datatask.Post(2807);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2808, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.state.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2813, this.edit))[0];
                    
                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.state.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadLineTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    acreportlayoutline_keyno: number;
    acreportlayout_keyno: number;
    acreportlayoutline_name: string;
    account_nos: string;
    blank_line_after: string;
    show_accounts_after: string;
    line_type: string;
    orderby: number;
    page_heading: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('acReportLayoutLine', {
//        templateUrl: 'views/components/views/acReportLayoutLine/acReportLayoutLine.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'acReportLayoutLineService', function ($stateParams, stateService, translateService, modalService, acReportLayoutLineService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let acReportLayoutKeyno = $stateParams.acreportlayout_keyno;
//            let acReportLayoutLineKeyno = $stateParams.acreportlayoutline_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                acReportLayoutLineKeyno: acReportLayoutLineKeyno,
//                edit: {},
//                selectListLineTypes: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await acReportLayoutLineService.getAcReportLayoutLine({
//                    acreportlayout_keyno: acReportLayoutKeyno,
//                    acreportlayoutline_keyno: acReportLayoutLineKeyno
//                }))[0];
//            }

//            async function loadLineTypes() {
//                vm.model.selectListLineTypes = await acReportLayoutLineService.listLineTypes();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                acReportLayoutLineService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    acReportLayoutLineService.deleteItem(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: (dialogItself) => {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadLineTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
